// Supported job-posting languages, shown as a dropdown on the New Job / Edit Job
// forms. The backend still stores free text, so adding a language here is the only
// change needed to support a new one.
export const SUPPORTED_JOB_LANGUAGES = [
  "English", "Thai", "Hindi", "Vietnamese", "Indonesian", "Chinese", "Khmer", "Lao", "Burmese",
];

// Best-effort BCP-47 locale for the HTML lang attribute, so browsers/screen readers
// render non-Latin scripts correctly. Unrecognized/custom values fall back to undefined
// (browser default) rather than guessing wrong.
const LOCALE_BY_LANGUAGE: Record<string, string> = {
  english: "en", thai: "th", hindi: "hi", vietnamese: "vi", indonesian: "id",
  chinese: "zh", khmer: "km", lao: "lo", burmese: "my",
};

export function localeForLanguage(language?: string | null): string | undefined {
  if (!language) return "en";
  return LOCALE_BY_LANGUAGE[language.trim().toLowerCase()];
}
